import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { Observable, Subscription } from 'rxjs';
import { ComponentDataShareService } from '../../services/component-data-share.service';
import { IntegrationService } from '../../services/integration.service';

@Component({
    selector: 'app-no-result-message',
    templateUrl: './no-result-message.component.html',
    styleUrls: ['./no-result-message.component.scss']
})
export class NoResultMessageComponent implements OnInit, INoRowsOverlayAngularComp {
  public params: INoRowsOverlayParams & { noRowsMessageFunc: () => string };
  public noResultIcon: string;
  public timeoutErrorIcon: string;
  erroMsgItem: Subscription;
  messagePassed: Observable<any>;

  constructor(
    private integrationService: IntegrationService,
    private domSanitizer: DomSanitizer,
    private componentDataShareService: ComponentDataShareService
  ) {}
  agInit(params: INoRowsOverlayParams & { noRowsMessageFunc: () => string }): void {
    this.params = params;
  }

  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    const noResult = assetUrl + 'assets/images/EmptyState_NoSearchResults.svg';
    this.noResultIcon = this.domSanitizer.sanitize(
      SecurityContext.RESOURCE_URL,
      this.domSanitizer.bypassSecurityTrustResourceUrl(noResult)
    );
    const timeoutError = assetUrl + 'assets/images/EmptyState_Maintenance.svg';
    this.timeoutErrorIcon = this.domSanitizer.sanitize(
      SecurityContext.RESOURCE_URL,
      this.domSanitizer.bypassSecurityTrustResourceUrl(timeoutError)
    );
    this.erroMsgItem = this.componentDataShareService.messagePassed$.subscribe((value) => {
      this.messagePassed = value;
    });
  }

  ngOnDestroy(): void {
    this.erroMsgItem.unsubscribe();
  }
}
